import { render, staticRenderFns } from "./DispatchingPolygonEditor.vue?vue&type=template&id=47a002fd&scoped=true"
import script from "./DispatchingPolygonEditor.vue?vue&type=script&lang=js"
export * from "./DispatchingPolygonEditor.vue?vue&type=script&lang=js"
import style0 from "./DispatchingPolygonEditor.vue?vue&type=style&index=0&id=47a002fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a002fd",
  null
  
)

export default component.exports